import { PortalMapFactory } from "@domain/factories/PortalMapFactory";
import { PortalMap, PortalType } from "@studyportals/domain-client";
import { useCookie } from "nuxt/app";

export const usePortalMap = (): PortalMap =>{
	const portalMapCookie = useCookie<string>('PortalMap').value;
	const portalMapFactory = new PortalMapFactory();

	if(import.meta.client){
		const windowPortalMap = (window as Window & { PortalMap?: Record<PortalType, string> }).PortalMap;
		return portalMapFactory.buildMap(windowPortalMap);
	}

	return portalMapFactory.buildMap(portalMapCookie);
}